import React from "react";
import Sidebar from "./Sidebar";
import ConversationSection from "../WebChat/ConversationSection";
import { ToastContainer } from "react-toastify";
import "../../assets/scss/ReactToastify.scss";
import "../../assets/scss/reset.scss";
import "../../assets/scss/common.scss";
import "./popup.scss";
import "./../Common/popup.scss";
import "./../../assets/scss/minEmoji.scss";
import WebChatMediaPreview from "../WebChat/ConversationSection/Conversation/WebChatMediaPreview";
import { useSelector } from "react-redux";
import "../../assets/scss/responsive.scss";
import "../../assets/scss/mobileView.scss";
import Connecting from "../WebCall/Connecting";
import { encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "../../Helpers/Chat/webChatEncryptDecrypt";
import CalleeScreen from "../WebCall/CalleScreen";
import WebCallingLayout from "../WebCall/WebCallingLayout";
import WebRtcCall from "../WebCall/WebRtcCall";
import { addShowConfrenceData } from "../../Redux/feature/showConfrenceDataSlice";
import ringingTone from "../WebCall/ringingtone";
import outgoingRinging from "../WebCall/outgoingRingingBase64";
import busySignal from "../WebCall/busySignalBase64";
import browserTab from "../../Helpers/Browser/BrowserTab";
import browserNotify from "../../Helpers/Browser/BrowserNotify";
import notificationSound from "../../Helpers/Browser/notificationBase64";
import useWindowSize from "../../hooks/useWindowSize";
import BlockedFromApplication from "../BlockedFromApplication";
import { resetSingleChatSelectedMedia } from "../../Redux/feature/singleChatSelectedMediaSlice";
import { store } from "../../Redux/store";
import { resetMessageData } from "../../Redux/feature/messageDataSlice";
import MeetingScreenJoin from "../WebCall/MeetingScreenJoin";
import { addCallIntermediate } from "../../Redux/feature/callIntermediateScreenSlice";

let callStatus = "";
export const Layout = (props = {}) => {
  const { darkTheme = "", enableDeviceSize = false, logOut, isCallEnabled = true ,customConversation : {  conversationValue = false,  } = {}} = props;
  const [getisShowPreviewMedia, setisShowPreviewMedia] = React.useState(false);
  const [hideCallScreen, setHideCallScreen] = React.useState(false);
  const [openStatus, setopenStatus] = React.useState(true);
  const singleChatSelectedData = useSelector((state) => state.singleChatSelectedMediaData);
  const showConfrenceData = useSelector((state) => state.showConfrenceData);
  const callIntermediateScreen = useSelector((state) => state.callIntermediateScreen);
  const adminBlockUser = useSelector((state) => state.adminBlockUser);
  const vCardData = useSelector((state) => state.vCardData);
  const { data : singleChatSelectedMedia = {}} = singleChatSelectedData
  const [showMessageinfo, setshowMessageinfo] = React.useState(false)
  const [enableMobileView, setEnableMobileView] = React.useState(false)
  const selectedMedia = singleChatSelectedMedia;
  const callConnectionDate = JSON.parse(getFromLocalStorageAndDecrypt("call_connection_status"));
  encryptAndStoreInLocalStorage("hideCallScreen", false);
  const windowSize = useWindowSize();
  
  const handleMediaShow = (data, state = false) => {
    setisShowPreviewMedia(state);
  };

  const handleIframeTask = (e) => {
    if (e.data === "returntoChat") {
      setHideCallScreen({ hideCallScreen: true });
    }
    if (e.data === "endcall") {
      store.dispatch(
        addShowConfrenceData({
          ...showConfrenceData,
          showComponent: false
        })
      );
    }
  };

  React.useEffect(()=>{
    if(document.getElementById("mf-root-Parent").parentElement.offsetWidth > 1024){
        window.addEventListener('resize', () => {
          if(enableDeviceSize === true){
            customResize();
          }
        });
        window.removeEventListener('resize', customResizeMw);
    }
    else {
      window.addEventListener('resize', () => {
        if(enableDeviceSize === true){
          customResizeMw();
        }
      });
      window.removeEventListener('resize', customResize);
    }
  },[])
  

  const customResize = () => {
    document.getElementById('mirrorFlyRoot').style.height = window.innerHeight + "px";
    document.getElementById('mirrorFlyRoot').style.width = window.innerWidth + "px";
    document.getElementById('mirrorFlyRoot').style.maxWidth = "100%";
  }
  const customResizeMw = () => {
    document.getElementById('mirrorFlyRoot').style.height = window.innerHeight + "px";
    document.getElementById('mirrorFlyRoot').style.width = "100%";
    document.getElementById('mirrorFlyRoot').style.maxWidth = window.innerWidth + "px";
  }

  React.useEffect(()=>{
    window.addEventListener("message", handleIframeTask);
    window.ringingTone = new Audio(ringingTone)
    window.outgoingRingTone = new Audio(outgoingRinging)
    window.busySignal = new Audio(busySignal)
    window.notifySound = new Audio(notificationSound)
    browserTab.init();
    browserNotify.init();
    if(document.getElementById("mf-root-Parent").parentElement.offsetWidth < 1025){
      setEnableMobileView(true);
      if(enableDeviceSize === true){
        customResizeMw()
      }
    }
  },[])

  React.useEffect(()=>{
    if(callConnectionDate === null && hideCallScreen) setHideCallScreen(false);
  },[callConnectionDate])

  React.useEffect(()=>{
    if(singleChatSelectedData.id && singleChatSelectedData.id !== null && singleChatSelectedData.data){
    setisShowPreviewMedia(true)}
  },[singleChatSelectedData.id])
  
  const handleMediaClose = () => {
    store.dispatch(resetSingleChatSelectedMedia());
    store.dispatch(resetMessageData())
    setisShowPreviewMedia(false)
  };

  const hideCallScreenAction = () => {
    encryptAndStoreInLocalStorage("hideCallScreen", true);
    setHideCallScreen(true);
  };

  const messageInfoShow = (valueToShowMsgInfo = false) => {  
    setshowMessageinfo (valueToShowMsgInfo)
};

  const handleShowCallScreen = () => {
    encryptAndStoreInLocalStorage("hideCallScreen", false);
    setHideCallScreen(false);
    if (callIntermediateScreen?.data?.hideCallScreen) {
      store.dispatch(addCallIntermediate({ hideCallScreen: false }));
    }
    
  };

  const hideCallScreens = () => {
    encryptAndStoreInLocalStorage("hideCallScreen", true);
    setHideCallScreen({ hideCallScreen: true });
  };

  React.useEffect(()=>{
    if(document.getElementById("mf-root-Parent").parentElement.offsetWidth < 1025){
      setEnableMobileView(true)
    } else {
      setEnableMobileView(false)
    }
  },[windowSize])

  React.useEffect(()=>{
    const { data: { toggleCallScreen, hideCallScreen } = {} } = callIntermediateScreen;
    if (toggleCallScreen) {
      encryptAndStoreInLocalStorage("hideCallScreen", toggleCallScreen);
      setHideCallScreen({ toggleCallScreen });
    }
    if (hideCallScreen && callIntermediateScreen?.data?.hideCallScreen) {
      if (callIntermediateScreen?.data?.hideCallScreen) {
        hideCallScreens();
      } else {
        handleShowCallScreen();
      }
    }
  },[callIntermediateScreen])

  const handlePopupState = (status) => {
    setopenStatus(status);
  };

  // const callfrom = callConnectionDate?.callMode === "onetoone" ?  callConnectionDate?.userJid : "" 
  let anotherUser = "";
  if (callConnectionDate && callConnectionDate.from && showConfrenceData?.data) {
    if (showConfrenceData?.data?.callStatusText) {
      callStatus = showConfrenceData.data.callStatusText;
    }
    if (callConnectionDate.callMode === "onetoone") {
      anotherUser = callConnectionDate.from;
      if (
        callConnectionDate.from.includes("@")
          ? callConnectionDate.from.split("@")[0]
          : callConnectionDate.from === vCardData?.data.fromUser
      ) {
        anotherUser = callConnectionDate.to;
        anotherUser = anotherUser.includes("@") ? anotherUser.split("@")[0] : anotherUser;
      }
    }
    if (callConnectionDate.callMode === "onetomany") {
      anotherUser =
        callConnectionDate.groupId !== undefined && callConnectionDate.groupId !== null
          ? callConnectionDate.groupId
          : callConnectionDate.from;
      anotherUser = anotherUser.includes("@") ? anotherUser.split("@")[0] : anotherUser;
    }
  }

  
  return (
    <>
    <div id="mirrorFlyRoot" className={`mirrorfly-root ${ enableMobileView === true ? " mobileView " : " " }`}>
      <div className={` ${darkTheme ? " dark-theme-active " : " "} boxLayout`}>
        {!adminBlockUser?.data?.isAdminBlocked && (
        <div className="container containerLayout" id="container">
          {showConfrenceData &&
            showConfrenceData.data &&
              showConfrenceData.data.showCalleComponent && (
                <div className={`${(hideCallScreen && "BackToConversion") || ""}`}> 
                  <CalleeScreen
                    callStatus={showConfrenceData.data.callStatusText}
                    stopSound={showConfrenceData.data.stopSound || ""}
                    hideCallScreen={hideCallScreenAction}  
                  />  
                </div>
          )}
          {callIntermediateScreen?.data?.show && (
            <MeetingScreenJoin callData={callIntermediateScreen?.data} />
          )}

          {!conversationValue &&
            <Sidebar 
              logout={logOut}
              callUserJID={anotherUser}
              callStatus={showConfrenceData.data.callStatusText}
              handleShowCallScreen={handleShowCallScreen}
              callType={(callConnectionDate && callConnectionDate.callType) || ""}
              callMode={(callConnectionDate && callConnectionDate.callMode) || ""}
              handlePopupState={handlePopupState}
              isCallEnabled = {isCallEnabled}
            /> 
          }
          
          <ConversationSection     
            handleMediaShow={handleMediaShow} 
            showMessageinfo = {showMessageinfo} 
            showonGoingcallDuration={hideCallScreen}
            openStatus={openStatus}
            handlePopupState={handlePopupState}
            handleShowCallScreen={handleShowCallScreen}
            conversationValue={conversationValue}
            messageInfoShow = {messageInfoShow}
            isCallEnabled = {isCallEnabled}
          />
          
          {getisShowPreviewMedia && (
            <WebChatMediaPreview
              jid={selectedMedia.jid}
              chatType={selectedMedia.chatType}
              selectedMessageData={selectedMedia.selectedMessageData}
              handleMediaClose={(e) => handleMediaClose()}
            />
          )}

          {showConfrenceData &&
            showConfrenceData.data &&
            vCardData &&
            vCardData.data &&
            showConfrenceData.data.showComponent && 
            (
              <div className={`connecting webrtc  ${(hideCallScreen && "visible") || ""}`}>
                <Connecting
                  // jid={jid}
                  fromuser={vCardData.data.fromuser}
                  hideCallScreen={hideCallScreenAction}
                />
              </div>
            )
          }
          
          {showConfrenceData &&
           showConfrenceData.data &&
            getFromLocalStorageAndDecrypt("callingComponent") === true && ( 
            <div className={`${(hideCallScreen && "BackToConversion") || ""}`}>
              <WebCallingLayout
                callStatus={showConfrenceData.data.callStatusText}
                stopSound={showConfrenceData.data.stopSound || ""}
                soundPath={showConfrenceData.data.soundPath || ""}
                hideCallScreen={hideCallScreenAction}
              />
            </div>
           )} 

          {showConfrenceData &&
            showConfrenceData.data &&
            showConfrenceData.data.showStreamingComponent &&
            callConnectionDate && (
              <div className={`connecting  ${(hideCallScreen && "visible") || ""}`}>
                <WebRtcCall
                  showConfrenceDataId={showConfrenceData.id}
                  remoteVideoMuted={showConfrenceData.data.remoteVideoMuted}
                  remoteAudioMuted={showConfrenceData.data.remoteAudioMuted}
                  localVideoMuted={showConfrenceData.data.localVideoMuted}
                  localAudioMuted={showConfrenceData.data.localAudioMuted}
                  hideCallScreen={hideCallScreenAction}
                  fromJid={showConfrenceData.data.fromJid}
                  status={showConfrenceData.data.status}
                  localStream={showConfrenceData.data.localStream}
                  remoteStream={showConfrenceData.data.remoteStream}
                />
              </div>
            )}

          <ToastContainer position="top-right" />           
        </div>
        )}
        {(adminBlockUser?.data?.isAdminBlocked) &&
          <div className="container containerLayout" id="container">
            <BlockedFromApplication />
          </div>
        }        
      </div>
      </div>
    </>
  );
};

